module.exports = __webpack_public_path__ + "static/media/Alie-Black.a2b2a428.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alie-Black.svg
// module id = 2178
// module chunks = 0